templateHelpers = require './template-helpers'
Adams = require 'app/scripts/lib/adams'

module.exports = templateHelpers(Adams)
